module.exports = __webpack_public_path__ + "img/icon-find-store.240852d8.svg";